<template>
  <div id="home">
    <!--导航-->
    <topHead style="float: right;position:fixed;z-index: 999;background-color: white;" ref="topHead"></topHead>
    <div style="height: 80px;width: 100%"></div>
    <!--轮播-->
    <div class="block">
        <div class="news-banner">
           <!--<span @click="windowOpen(firstBanner.url)">-->
           <span>
                <!--<img :src="firstBanner.picture">-->
             <img src="@/assets/images/homebg.jpg">
           </span>
        </div>
      <div class="downWare">
        <el-row type="flex" class="row-bg" justify="space-around">
          <el-col :span="5"></el-col>
          <el-col :span="5" class="down-set"><a href="http://kdslow.com/version/client/KD_Cloud_Printer(x64)_V14.exe" target="_blank">
            <img src="@/assets/images/images01/winLite.png">
          </a></el-col>
          <!--<el-col :span="5" class="down-set"><a target="_blank" href="http://app.kdslow.com:82/client/KD_Cloud_Printer_full.exe">-->
            <!--<img src="@/assets/images/images01/winFull.png">-->
            <!--</a></el-col>-->
          <el-col :span="4"></el-col>
          <el-col :span="5" class="down-set" ><a>
            <img src="@/assets/images/images01/appVer.png" @click="downLoad(3)">
          </a></el-col>
          <el-col :span="5"></el-col>
        </el-row>
      </div>
    </div>
    <!--内容-->
    <div class="main">
      <!--第一栏-->
      <div class="type-set">
        <el-row type="flex" class="row-bg row-title" justify="space-around">
          <el-col :span="4" class="main-title"><p>打印类型</p><span>PRINT TYPE</span></el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="space-around">
          <el-col :span="6" class="type-box">
            <div class="bg">
              <img src="@/assets/images/images01/word_01.png">
            </div>
            <h5>文档</h5>
            <p>论文/讲义/资料/简历</p>
            <p>黑白/彩色/A3/A4/单面/双面</p>
            <p>doc/xls/ppt/pdf</p>
          </el-col>
          <el-col :span="6" class="type-box">
            <div class="bg">
              <img src="@/assets/images/images01/picture.png">
            </div>
            <h5>照片</h5>
            <p>生活照/手机照/纪念照</p>
            <p>拍摄/精修/管理/冲洗</p>
            <p>jpg/png/psd</p>
          </el-col>
          <el-col :span="6" class="type-box">
            <div class="bg">
              <img src="@/assets/images/images01/advert_01.png">
            </div>
            <h5>图文</h5>
            <p>海报/展架/横幅/喷绘</p>
            <p>胶装/防水/打孔/覆膜</p>
            <p>ai/psd/cad</p>
          </el-col>
        </el-row>
      </div>
      <!--第二栏-->
      <div class="type-set">
        <el-row type="flex" class="row-bg row-title" justify="space-around">
          <el-col :span="4" class="main-title"><p>产品特点</p><span>PRODUCT FEATURES</span></el-col>
        </el-row>
        <el-row type="flex" class="row-bg line-set" justify="space-around">
          <el-col :span="7">
            <div class="features-icon"><img src="@/assets/images/images01/time_01.png"></div>
            <div class="feature-text">
              <h3>全天候</h3>
              <p>7*24小时提供服务，永不停业</p>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="features-icon"><img src="@/assets/images/images01/juli.png"></div>
            <div class="feature-text">
              <h3>近距离</h3>
              <p>服务网点多，再也不用长途跋涉</p>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="features-icon"><img src="@/assets/images/images01/give_good.png"></div>
            <div class="feature-text">
              <h3>功能强</h3>
              <p>支持所有格式文件，打印类型多样</p>
            </div>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="space-around">
          <el-col :span="7">
            <div class="features-icon"><img class="min" src="@/assets/images/images01/yinsi.png"></div>
            <div class="feature-text">
              <h3>重隐私</h3>
              <p>加密传输，手机整理，安全可靠</p>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="features-icon"><img class="min" src="@/assets/images/images01/zhiliang.png"></div>
            <div class="feature-text">
              <h3>高品质</h3>
              <p>工业级设备，给您高品质的打印体验</p>
            </div>
          </el-col>
          <el-col :span="7">
            <div class="features-icon"><img class="min" src="@/assets/images/images01/api_param03.png"></div>
            <div class="feature-text">
              <h3>跨平台</h3>
              <p>打通电脑和手机，让您随时随地打印</p>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!--底部-->
    <bottom ref="bottom"></bottom>
  </div>
</template>

<script>
import axios from 'axios'
import bottom from './common/Bottom'
import topHead from './common/TopHead'
import * as Api from '../assets/js/Api'

export default {
  data () {
    return {
      banner: [],
      firstBanner: [],
      curBannerImg: ''
    }
  },
  created () {
    Api.changeClass = 0
    // this.getBannerList()
  },
  components: {
    bottom: bottom,
    topHead: topHead
  },
  methods: {
    // 打开外链
    windowOpen (url) {
      window.open(url)
    },
    getBannerList () {
      axios.get(Api.bannerList + '?type=' + 1).then((response) => {
        this.firstBanner = response.data[0]
      }, (response) => {
        window.bus.$message({
          message: '请求超时，请检查网络',
          type: 'warning'
        })
      })
    },
    // 下载
    downLoad (flag) {
      // 简版
      if (flag === 1) {
        fetch(Api.winDownLoad + '?edition=' + 'lite')
          .then(response => response.json())
          .then(responseJson => {
            window.open(responseJson.data)
          })
      }
      if (flag === 2) {
        fetch(Api.winDownLoad + '?edition=' + 'full')
          .then(response => response.json())
          .then(responseJson => {
            window.open(responseJson.data)
          })
      }
      if (flag === 3) {
        const aLiUrl = require('../assets/images/appDown.png')
        window.bus.$alert('<img src="' + aLiUrl + '" class="code-set">', '请使用手机，扫描下方二维码', {
          dangerouslyUseHTMLString: true,
          center: true
        })
      }
    }
  }
}
</script>

<style>
  .news-banner {
    width: 100%;
    height: 550px;
  }

  .news-banner img {
    width: 100%;
    height: 550px;
  }
  .nav-content {
    width: 100%;
    height: 80px;
    box-shadow: 3px 3px 10px -2px rgba(0,0,0,0.1);
  }

  .logo-contain {
    float: left;
    padding-top: 15px;
  }

  .logo-set {
    width: auto;
    height: 50px;
    vertical-align: center;
    margin-right: 10px;
  }

  .logo-text {
    display: inline-block;
    text-align: left;
    vertical-align: top;
  }

  .logo-text p {
    font-size: 20px;
    color: #333;
  }

  .logo-text small {
    font-size: 14px;
    color: #999;
  }

  .nav-list {
    float: right;
  }

  .nav-list li {
    display: inline-block;
    height: 50px;
    width: 150px;
  }

  .nav-list li a {
    border-bottom: 2px solid #fff;
    width: 100px;
    color: #333;
    font-size: 16px;
    line-height: 78px;
  }

  .nav-list li a:hover {
    color: #f62828;
    border-bottom: 2px solid #f62828;
  }

  .nav-list li .a-active {
    color: #f62828;
    border-bottom: 2px solid #f62828;
  }

  .block {
    position: relative;
  }

  .el-carousel {
    width: 100%;
    height: 550px;
  }

  .el-carousel img {
    width: 100%;
    height: 100%;
  }

  .is-active .el-carousel__button {
    background-color: #00f1ff;
  }

  .el-carousel__button {
    height: 5px;
    background-color: rgba(0, 0, 0, 0.3);
  }

  .el-carousel__arrow:hover {
    background-color: #cf0631;
  }

  .downWare {
    width: 100%;
    position: absolute;
    bottom: 40px;
    z-index: 10;
  }

  .down-set a {
    width: 100%;
    background-color: #fa4848;
    height: 60px;
    border-radius: 8px;
    text-align: center;
  }

  .down-set a:hover {
    background-color: #bd0404;
  }

  .down-set span {
    font-size: 18px;
    color: #fff;
    position: relative;
    top: -5px;
    line-height: 60px;
  }

  .down-set img{
    height: 50px;
    margin:5px auto;
  }

  .el-icon-download {
    color: #fff;
    font-size: 30px;
    line-height: 60px;
  }

  .main {
    width: 1200px;
  }

  .type-set {
    width: 100%;
    margin-bottom: 80px;
  }

  .main-title {
    padding-bottom: 10px;
    border-bottom: 1px solid #ddd;
  }

  .main-title p {
    color: #333;
    font-size: 22px;
    margin-bottom: 10px;
  }

  .main-title span {
    color: #bbb;
    font-size: 16px;
  }

  .row-title {
    margin: 50px;
  }

  .type-box {
    height: 340px;
    padding-top: 30px;
    border: 1px solid #ddd;
    border-radius: 3px;
    box-shadow: 3px 5px 10px -2px rgba(0, 0, 0, 0.09),
    -3px -5px 10px -2px rgba(0, 0, 0, 0.09);
    text-align: center;
  }

  .type-box img {
    width: 80px;
    height: 80px;
    margin-top: 5px;
  }
  .type-box .bg {
    width: 120px;
    height: 120px;
    padding: 15px;
    margin: 10px auto;
    background-color: #ECECEC;
    border-radius: 50%;
  }

  .type-box h5 {
    font-size: 20px;
    color: #333;
    font-weight: normal;
    line-height: 40px;
  }

  .type-box h6 {
    font-size: 14px;
    color: #999;
    font-weight: 100;
    line-height: 20px;
  }

  .type-box p {
    font-size: 14px;
    color: #555;
    line-height: 30px;
  }

  .line-set {
    margin-bottom: 50px;
  }

  .features-icon {
    display: inline-block;
    width: 50px;
    height: 50px;
    padding: 5px;
    background-color: #ECECEC;
    border-radius: 50%;
    vertical-align: top;
  }

  .features-icon img {
    width: 40px;
    height: 40px;
  }
  .features-icon .min {
    width: 30px;
    height: 30px;
    margin: 5px;
  }

  .feature-text {
    width: 150px;
    display: inline-block;
    text-align: left;
    margin-left: 10px;
    vertical-align: top;
  }

  .feature-text h3 {
    color: #FB3838;
    font-size: 18px;
    margin-bottom: 10px;
  }

  .feature-text p {
    font-size: 14px;
    color: #555;
    line-height: 25px;
    word-break: break-all;
  }

  .common-bottom {
    width: 100%;
    background-color: #434343;
    color: rgba(255, 255, 255, 0.8);
    text-align: left;
    padding: 30px 0px;
  }

  .bottom-ul h5 {
    font-size: 18px;
    font-weight: normal;
    width: 50%;
    border-bottom: 1px solid #fff;
    padding-bottom: 10px;
    margin-bottom: 10px;
    margin-left: 0px;
  }

  .bottom-ul a, .bottom-ul span {
    font-size: 14px;
    line-height: 25px;
  }

  .bottom-ul span {
    margin-left: 5px;
  }
  .bottom-ul a {
    color: rgba(255, 255, 255, 0.8);
  }
  .bottom-ul a:hover {
    color: rgba(255, 255, 255, 0.8);
    text-decoration: underline;
  }

  .code-set {
    width: 120px;
    height: 120px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Home.vue